import { useCallback } from "react"
import { useNavigate, useParams } from "react-router"
import { ConfirmLayout } from "@/templates/ConfirmLayout"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { genCleaningReportPagePath } from "@/routes/protected"
import { useTranslation } from "@/hooks/useTranslation"

export const ReadyForErrandsPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)
    const gotoErrands = useCallback(() => {
        navigate(genCleaningReportPagePath(cleaningId, "errands"))
    }, [cleaningId, navigate])
    return (
        <ConfirmLayout
            title={t("お願い事の撮影へ移動します")}
            primaryButtonLabel={t("次へ")}
            next={gotoErrands}
        />
    )
}
